import React, { useId, useState } from 'react';
import { Info } from 'lucide-react';

export function RecipeFieldHelp({ label, children }: { label: string; children: React.ReactNode }) {
  const [open, setOpen] = useState(false), [pinned, setPinned] = useState(false);
  const id = useId();
  return <span className="recipe-field-help" onMouseEnter={() => setOpen(true)} onMouseLeave={() => { if (!pinned) setOpen(false); }}
    onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget as Node | null)) { setOpen(false); setPinned(false); } }}>
    <button type="button" className="recipe-help-button" aria-label={label} aria-expanded={open} aria-describedby={open ? id : undefined}
      onFocus={() => setOpen(true)} onClick={() => { setPinned(!pinned); setOpen(!pinned); }}
      onKeyDown={event => { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); setOpen(false); setPinned(false); } }}><Info size={15} aria-hidden="true" /></button>
    {open && <span id={id} role="tooltip" className="recipe-help-content">{children}</span>}
  </span>;
}
